import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useCart from "../../hooks/useCart";
import { toast } from "react-hot-toast";
import { ascendraPlusPlan } from "../../constants/plans";

const AscendraPlusModal = ({ setShowPayment, showPayment }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleCloseModal = () => {
    setShowPayment(false);
  };

  const handleCheckout = () => {
    toast.loading("Redirecting to payment...", { id: "payment" });
    try {
      addToCart(ascendraPlusPlan);
      toast.dismiss("payment");
      navigate("/checkout");
    } catch (error) {
      toast.dismiss("payment");
      toast.error(
        error.message || "Failed to initiate payment. Please try again."
      );
    }
  };

  if (!showPayment) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 overflow-y-auto p-5"
      onClick={handleCloseModal}
    >
      <div
        className="relative w-full max-w-[900px] mx-auto text-white"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          className="fixed top-[30px] right-[30px] w-11 h-11 rounded-full bg-slate-900/90 border border-slate-600/50 text-white text-3xl font-light cursor-pointer z-[100] flex items-center justify-center transition-all duration-200 hover:scale-110 hover:bg-[#e6a04d]/20"
          onClick={handleCloseModal}
        >
          ×
        </button>

        {/* Container */}
        <div className="text-center px-10 py-16">
          {/* Top Navigation */}
          <div className="flex justify-center items-center gap-4 mb-12">
            <div className="font-bold text-xl flex items-center gap-2">
              ✦ Ascendra Plus
            </div>
            <div className="border border-white/40 px-3 py-1 rounded-full text-sm">
              42 Days Complete
            </div>
          </div>

          {/* Hero Text */}
          <h1 className="font-serif text-5xl leading-tight mb-5">
            You've found your freedom.
            <br />
            Now, make it permanent.
          </h1>
          <p className="text-gray-400 text-lg max-w-[650px] mx-auto mb-12 leading-relaxed">
            After 42 days of release and control, your momentum is real.
            Ascendra Plus is where that progress compounds into a new identity.
          </p>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-12 text-left">
            <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-sm">
              <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
                🧠 The Guide
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                Your AI Coach: It knows your rhythm, your inner edge. Stay
                guided by the intelligence that evolved with you.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-sm">
              <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
                📈 The Growth
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                Neural Monitoring: Strengthening new pathways. Make the
                "effortless" days your lifetime standard.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-sm">
              <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
                👥 Community
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                Global Support: Real people. Real conversations. Be held by a
                community that understands the rise.
              </p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-sm">
              <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
                📊 Identity
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                Evolution Tracking: Don't just track habits—track your
                evolution. Watch your new self lock in for good.
              </p>
            </div>
          </div>

          {/* Quote */}
          <div className="italic text-xl mb-8 text-gray-400">
            "They've already begun your rise; Now let's
            <br />
            sure make it who you are."
          </div>

          {/* CTA Button */}
          <button
            className="bg-gradient-to-r from-[#e6a04d] to-[#d48a3b] text-white border-none px-10 py-4 rounded-full text-lg font-bold cursor-pointer shadow-[0_4px_15px_rgba(230,160,77,0.3)] transition-transform hover:scale-105"
            onClick={handleCheckout}
          >
            Join Ascendra Plus — ${ascendraPlusPlan.price}/month
          </button>

          {/* Footer Note */}
          <div className="mt-4 text-sm text-gray-400">
            Stay as long as you keep rising. Cancel anytime.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AscendraPlusModal;
